import { FileTypes } from './model';
import { Groups, SelectMode } from '../../../models';
import {
  getTotals as getTotalsDevices,
  TotalsByTypeDefault,
} from '../../devices';
import { getTotals as getTotalsOrders } from '../../orders';
import { getTotals as getTotalsDTypes } from '../../devicetypes';
import { getTotals as getTotalsCustomers } from '../../customers';

export const isValidKemPassword = (pwd: string) =>
  pwd && pwd.length >= 5 && pwd.length <= 16;

export const isDownloadable = (filetype: string, pwd: string) =>
  filetype !== FileTypes.KEM || isValidKemPassword(pwd);

export const getMode = (groupedBy: Groups, keys: string[] = []) =>
  groupedBy === Groups.DEVICES && keys.length === 0
    ? SelectMode.All
    : SelectMode.Selected;

export const getTotals = (
  groupedBy: Groups,
  mode: SelectMode,
  keys: string[]
) => {
  switch (groupedBy) {
    case Groups.DEVICES:
      return mode === SelectMode.Selected
        ? getTotalsDevices(keys)
        : getTotalsDevices();
    case Groups.ORDERS:
      return getTotalsOrders(keys);
    case Groups.DEVICETYPES:
      return getTotalsDTypes(keys);
    case Groups.CUSTOMERS:
      return getTotalsCustomers(keys);
    default:
      return TotalsByTypeDefault;
  }
};
